import mixin, { CellBelong } from './mixins'

export default {
  name: 'KDataGridRowFooter',
  mixins: [mixin],
  props: {},
  data() {
    return {
      cellBelong: CellBelong.ROW_FOOTER,
    }
  },
  computed: {},
  watch: {},
  created() {
  },
  mounted() {
  },
  destroyed() {
  },
  methods: {
    handleScroll() {
      this.layout.apiHandleRowFooterScroll(event)
    },
  },
  render() {
    const style = {}

    const css = {
      'km-data-grid__row-footer': true,
    }

    const attrs = {}

    const events = {
      scroll: this.handleScroll,
    }

    const data = {
      style: style,
      class: css,
      attrs: attrs,
      on: events,
    }

    return <div {...data}>
      {this.renderFixedColumns()}
      {this.renderCenterColumns()}
      {this.renderFixedColumns(true)}
    </div>
  },
}
